import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsProvider } from '@3plearning/mx-teacher-analytics/react';
import buildAnalyticsClient from './create-client';
import { getAnalyticsBuildConfig } from './config';
import AnalyticsListener from '../tracking/analytics-listener';

export default function MxAnalyticsProvider({ children }) {
  const [client] = useState(() =>
    buildAnalyticsClient(getAnalyticsBuildConfig())
  );

  return (
    <AnalyticsProvider client={client}>
      <AnalyticsListener />
      {children}
    </AnalyticsProvider>
  );
}

MxAnalyticsProvider.propTypes = {
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./analytics/client/mx-analytics-provider.js